import { Injectable } from '@angular/core';

export interface LoggerProvider {
    debug(template: string, ...optionalParams: any[]): void;
    info(template: string, ...optionalParams: any[]): void;
    warning(template: string, ...optionalParams: any[]): void;
    error(template: string, ...optionalParams: any[]): void;
}

@Injectable()
export class ConsoleProvider implements LoggerProvider {
    debug(template: string, ...optionalParams: any[]): void {
        console.debug(template, ...optionalParams);
    }

    info(template: string, ...optionalParams: any[]): void {
        console.log(template, ...optionalParams);
    }

    warning(template: string, ...optionalParams: any[]): void {
        console.warn(template, ...optionalParams);
    }

    error(template: string, ...optionalParams: any[]): void {
        console.error(template, ...optionalParams);
    }
}
